import React from 'react';
import {Container} from '@material-ui/core';
import {BrowserRouter,Switch,Route} from 'react-router-dom'
import Navbar from './components/Navbar/Navbar'
import Home from './components/Home/Home'
import Auth from './components/Auth/Auth';
import useStyles from './styles';

function App() {
  const classes = useStyles();
  return (
    //react routing for auth 
    <BrowserRouter>
      <Container maxidth="lg">
        <Navbar/>
        <Switch>
          <Route path="/" exact component={Home}/>
          <Route path="/auth" exact component={Auth}/>
        </Switch>
      </Container>
    </BrowserRouter>
  
  );
}

export default App;
